<ama-page-ribbon></ama-page-ribbon>
<ama-profile-sheet-dialog></ama-profile-sheet-dialog>
<ama-search-sidebar></ama-search-sidebar>
<router-outlet></router-outlet>
<ama-cookie></ama-cookie>
